'use client'

import { useEffect, useState } from 'react'

// Constants
const COOKIE_NAME = 'cookieConsent'
const COOKIE_EXPIRATION_DAYS = 365 // 365 days validity

// Utility functions for cookie operations
const setCookie = (name: string, value: string, days: number) => {
  const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString()
  document.cookie = `${name}=${value}; expires=${expires}; path=/`
}

const getCookie = (name: string): string | null => {
  if (typeof document === 'undefined') return null
  const cookie = document.cookie.split('; ').find((cookie) => cookie.startsWith(`${name}=`))
  if (cookie) {
    const value = cookie.split('=')[1]
    return value ? value : null // Return null if the value is undefined
  }
  return null
}

export const useCookieConsent = () => {
  const [consentStatus, setConsentStatus] = useState<boolean | null>(null)
  const [hasGivenAction, setHasGivenAction] = useState<boolean>(false)

  useEffect(() => {
    const storedConsent = getCookie(COOKIE_NAME)

    if (storedConsent === 'true') {
      setConsentStatus(true)
      setHasGivenAction(true)
    } else if (storedConsent === 'false') {
      setConsentStatus(false)
      setHasGivenAction(true)
    }
  }, [])

  const giveConsent = () => {
    setCookie(COOKIE_NAME, 'true', COOKIE_EXPIRATION_DAYS)
    setConsentStatus(true)
    setHasGivenAction(true)
  }

  const giveDiscent = () => {
    setCookie(COOKIE_NAME, 'false', COOKIE_EXPIRATION_DAYS)
    setConsentStatus(false)
    setHasGivenAction(true)
  }

  return { consentStatus, giveConsent, giveDiscent, hasGivenAction }
}
